import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RefreshTokenRequest } from '../models/refreshTokenRequest';
import { TokenRefreshResponse } from '../models/tokenRefreshResponse';
import { ServiceResponse } from '../models/serviceResponse.model';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.baseUrl;

  generateRefreshToken(data: RefreshTokenRequest): Observable<ServiceResponse<TokenRefreshResponse>> {
    const url = this.baseUrl + '/authorization/RefreshToken';
    return this.http.post<ServiceResponse<TokenRefreshResponse>>(url, data);
  }

  revokeRefreshToken() {
   const url = this.baseUrl + '/token/revoke';
   return this.http.post(url, null);
  }
}
